/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";


/**
 * Restaurant store
 */
window.$(".saveRestaurants").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveRestaurants').attr('disabled', 'disabled');
    let formdata = new FormData($("form.restaurantsForm")[0]);
    window.axios({
        method: "post",
        url: window.$(".restaurantsForm").attr('action'),
        headers: { "Content-Type": "multipart/form-data" },
        data: formdata,
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function (error) {
            window.$('.saveRestaurants').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Restaurant update
 */
window.$(".updateRestaurants").on('click', function (e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    // window.$('.updateRestaurants').attr('disabled', 'disabled');
    let formdata = new FormData($("form.restaurantUpdateForm")[0]);
    window.axios({
        method: "POST",
        url: window.$(".restaurantUpdateForm").attr('action'),
        headers: { "Content-Type": "multipart/form-data" },
        data: formdata,
    })
        .then(function (response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function () {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function (error) {
            window.$('.updateRestaurants').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function (key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Admin Restaurant table listing
 */

var table = window.$('.restaurantTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".restaurantTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false},
        { data: 'name', name: 'name' },
        { data: 'location', name: 'location' },
       /* { data: 'status', name: 'status', orderable: false, className: "status" },*/
        { data: 'is_default', name: 'is_default', searchable: false, "visible": window.$('.restaurantTable').find('th').hasClass('hide-default')? false : true },
        { data: 'Widget', name: 'Widget', orderable: false,  searchable: false },
        { data: 'action', name: 'action',  orderable: false,  searchable: false },
    ],
    order: []
});


/**
 * Operation center table listing
 */

 var tableOC = window.$('.OcRestaurantTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": DATATABLE_MENU_LENGTH_OPTIONS,
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".OcRestaurantTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false},
        { data: 'restaurantId', name: 'restaurantId', width: '10%'},
        { data: 'name', name: 'name', width: '25%' },
        { data: 'location', name: 'location', width: '25%' },
        { data: 'owners', name: 'owners', width: '25%'},
        { data: 'status', name: 'status', orderable: false, className: "status" },
        { data: 'is_default', name: 'is_default', searchable: false, "visible": window.$('.OcRestaurantTable').find('th').hasClass('hide-default')? false : true },
        { data: 'Widget', name: 'Widget', orderable: false,  searchable: false },
        { data: 'action', name: 'action',   searchable: false , orderable:false, width: '10%'},
    ],
    order: [],
    
});

/**
 * Delete Restaurant
 */
window.$(document).on('click', '.deleteRestaurant', function (e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function (result) {
        // If confirmation true, do action for delete
        var myTable = $(".OcRestaurantTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".OcRestaurantTable").attr('link')
        });
        e.preventDefault();
        window.axios({
            method: "DELETE",
            url: currentObj.attr('link')
        })
            .then(function (response) {
                window.toastr.success(response.data.message, response.statusText);
                setTimeout(function () {
                    window.location = "/oc/restaurant";
                }, 1000);
            })
            .catch(function (error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function (err) {
        console.log(err);
        return false;
    });

});

// change status of restaurant
window.$(document).on('click', '.OcRestaurantTable .status_checkbox', function (e) {

    window.$(".error").html('');
    window.toastr.remove();
    var is_updated = true;
    // If confirmation true, do action for delete
    var myTable = $(".OcRestaurantTable").DataTable({
        bRetrieve: true,
        ajax: window.$(".OcRestaurantTable").attr('link')
    });
    var id = window.$(this).closest("tr").attr('id');
    if (typeof id !== "undefined" && id !== '') {
        var status = (window.$(this).is(':checked')) ? 'on' : 'off';

        var queryString = '/' + id;
        var currentObj = window.$(this);
        var data = {
            'id': id,
            'status': status,
            'update_status': true
        }

        onlyStatusChange(queryString, data, 12).then((response) => {
            console.log(window.$(this).html());
            if (response.status == true) {
                window.toastr.success(response.message, response.statusText);
            } else {
                currentObj.prop("checked", true);
                window.toastr.error(response.message, response.statusText);
            }
        });

    }
});

window.$(document).ready(function () {
    // Setup - add a text input to each footer cell
    var excluded_columns = [5,6,7];
    searchByTableColumns(tableOC, '.OcRestaurantTable', excluded_columns);

    var excluded_columns = [3,4,5,6];
    searchByTableColumns(table, '.restaurantTable', excluded_columns);

    // UPLOAD VALIDATION
    $('#restaurantLogo').on("change", function () {
        $(this).css('border', 'none');
        $('#restaurant-logo-error').html('');
        var fileExtension = ['jpeg', 'jpg', 'png'];
        if ($.inArray($(this).val().split('.').pop().toLowerCase(), fileExtension) == -1) {
            $(this).css('border', '1px solid red');
            $(this).html(this.value);
            $('#restaurant-logo-error').html("Only '.jpeg','.jpg','.png' formats are allowed.");
        } else {

        }
    })
});

window.$(document).ajaxComplete(function () {
    window.$('[data-toggle="tooltip"]').tooltip()
});

function onlyStatusChange(queryString, data, currentObj) {
    return window.axios({
        method: queryString == '' ? "post" : "put",
        url: window.$(".OcRestaurantTable").attr('link') + queryString,
        data: data
    })
        .then(function (response) {
            return {
                status: true,
                message: response.data.message,
                statusText: response.statusText,
                currentObj: currentObj

            }

        })
        .catch(function (error) {
            return {
                status: false,
                message: error.response.data.message,
                statusText: error.response.statusText,
                currentObj: currentObj

            }

        });
}